export interface VisualizerState {
	settings: { open: boolean };
}

export const initialVisualizerState: VisualizerState = {
	settings: { open: false },
};
